<mat-dialog-content style="max-height: 60vw">
  <div id="w3l-appointment">
  <section class="w3l-form-25">
    <div class="form-inner-cont">
      <div class="w3l-form-25">
          <h1>{{'Clinical Examination' | translate }}</h1>
      </div>
    </div>
  </section>

<div class="styled-input">
  <div class="accounts" style="left: 50px;">

    <div class="appointment-form-field">
      <label style="font-size: large;font-weight: bold;left: 150px;">     </label>

      <label style="font-size: large;font-weight: bold;left: 50px;">{{patientcode}}</label>
      <label style="font-size: large;font-weight: bold;left: 150px;">     </label>
      <label style="font-size: large;font-weight: bold;left: 190px;">{{patientname}}</label>
    </div>
    <ul>
      <label style="font-size: large;font-weight: bold;left: 150px;">     </label>

      <label style="font-size: large;font-weight: bold;">Date :{{examdate}}</label>
      <label style="font-size: large;font-weight: bold;">     </label>
      <label style="font-size: large;font-weight: bold;">Time : {{examtime}}</label>
    </ul>
  </div>
  <mat-divider></mat-divider>
  <br>
  <div class="appointment-form-field">
    <label style = "width: 20%;">Date </label>
    <input type="date" name="site" [(ngModel)]="examdate" style="width: 20%;" required="" />
    <label style = "width: 20%;"></label>
    <label style = "width: 15%;">Location </label>
    <select id="PatientStatus" name="PatientStatus" [(ngModel)]="examlocation" style="width: 33.5%;background-color:  rgb(187, 203, 238);"  required>
        <option value="{{doc.compCode}}"  *ngFor="let doc of companyList; let i = index">{{doc.compName}}</option>
      </select>
  </div>

  <div class="appointment-form-field">
    <label style = "width: 18.2%;">Performance status </label>
    <select id="PatientStatus" name="PatientStatus"  [(ngModel)]="examperfstatus" style="width: 19.5%;background-color:  rgb(187, 203, 238);"  required>
      <option value="">Select*</option>
      <option value="0">0</option>
      <option value="1">1</option>
      <option value="2">2</option>
      <option value="3">3</option>
      <option value="4">4</option>

  </select>
  </div>

</div>

  <!-- <label>Clinical Examamination</label>
  <br>
  <br> -->
  <br>
  <br>
  <br>
  <br>
  <div class="appointment-form-field">
    <!-- <span class="fa fa-search-plus" aria-hidden="true" style="height: 200%;cursor: zoom-in;"  title="Zoom In"></span>
    <textarea rows = "15" cols = "60" name = "Diagnosis" [(ngModel)]= "examnotestext" class="appointment-form-field" style="height: 200%;"  > Enter details here... </textarea><br> -->
    <angular-editor  [config]="editorConfigNoToolbar"  [placeholder]="'Enter text here...'" [(ngModel)]="examnotes" (ngModelChange)="updatePlainText()"></angular-editor>

  </div>

</div>
<BR>
<BR>
  <BR>
    <BR>
      <BR>

<mat-divider></mat-divider>
<BR>

<form style="width: 100%;text-align: center;">
    <label style="width: 25%;"></label>
    <button type="button" class="theme-button btn" style="width: 10%;height: 60px; font-weight: bold;background-color: rgb(0, 86, 0);color: white; border-style: none;height: 60%;" name="submit" (click)="Save_Data()" >{{ 'Submit' | translate }}</button>
    <button type="button" class="theme-button btn" style="width: 10%;height: 60px;font-weight: bold;background-color: rgb(1, 19, 58);color: white;border-style: none;height: 60%;" name="Back" (click)="Exit_Data()">{{ 'Exit' | translate }}</button>

    <label style="width: 25%;"></label>
</form>



